import { GeoserverWMSProvider } from '../GeoserverWMSProvider'
import { WmsBaseLayer } from './WmsBaseLayer'

export class WmsFzuBouyLayer extends WmsBaseLayer {
  layername: string = '物标'
  key: string = 'fzubouy'
  provider = new GeoserverWMSProvider({
    url: 'iserver/services/map-ugcv5-WuBiao2/wms111/物标2',
    layers: '物标2',
  })
}
